var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header-title",on:{"click":_vm.goHome}},[_c('img',{attrs:{"src":"img/logo-small.svg","alt":"FISHOLA"}}),(_vm.envName)?_c('span',{staticClass:"env"},[_vm._v("("+_vm._s(_vm.envName)+")")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }